interface ProfilePasswordInput {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

/**
 * Client-side validation for the profile password form.
 * Returns an error message, or null when valid.
 */
export function validateProfilePasswordChange({
  currentPassword,
  newPassword,
  confirmPassword,
}: ProfilePasswordInput): string | null {
  if (!currentPassword || !newPassword || !confirmPassword) {
    return "All password fields are required.";
  }
  if (newPassword.length < 8) {
    return "New password must be at least 8 characters.";
  }
  if (newPassword !== confirmPassword) {
    return "New password and confirmation do not match.";
  }
  return null;
}
